const get = require('lodash/get')

const generatePurchaseOrderItems = (products) => {
  return Object.keys(products).reduce((acc, product) => {
    acc.push({
      sku: product,
      quantity: get(products[product], 'quantity', 0),
      comments: ['']
    })
    return acc
  }, [])
}

const getCustomerDetails = (location = {}) => {
  const customer = {
    fullName: location.name,
    address: location.address,
    state: location.state,
    country: location.country,
    city: location.city,
    status: location.status === true ? 'Active' : 'Inactive',
    email: location.email,
    phone: location.phoneNumber,
    name: location.ownerName,
    code: location.code
  }

  return customer
}

const generatePurchaseOrder = (shipment, locationUuidById) => {
  // Transform the order object as needed
  const items = generatePurchaseOrderItems(shipment.counts)
  const destination = locationUuidById[shipment.destinationId]
  const origin = locationUuidById[shipment.originId]

  return {
    destinationId: get(destination, 'code'),
    supplierId: get(origin, 'uuid'),
    status: shipment.deleted ? 'cancelled' : 'accepted',
    orderId: shipment.shipmentNumber,
    orderType: 'supplier_purchase',
    items,
    supplier: getCustomerDetails(origin)
  }
}

module.exports = generatePurchaseOrder
